import { css } from '@emotion/react';

export const dorosiwaCss = css`
  .swiper-wrapper {
    display: flex;

    .swiper-slide {
      flex-shrink: initial;
    }
  }
`;
